// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCuEcoLhnLYGhgcc2oZ4Hl5D3fBrHzlf3Y",
    authDomain: "portfolio-acaa2.firebaseapp.com",
    projectId: "portfolio-acaa2",
    storageBucket: "portfolio-acaa2.appspot.com",
    messagingSenderId: "1004361631745",
    appId: "1:1004361631745:web:20ea52345758151a299800",
    measurementId: "G-H46Q7XMRFF"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
